// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/inter/Inter-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/fonts/inter/Inter-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/fonts/inter/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/fonts/inter/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/fonts/inter/Inter-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/fonts/inter/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../assets/fonts/inter/Inter-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'inter';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-style: normal;
  font-weight: 200;
}

@font-face {
  font-family: 'inter';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-style: normal;
  font-weight: 300;
}

@font-face {
  font-family: 'inter';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: 'inter';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
  font-style: normal;
  font-weight: 500;
}

@font-face {
  font-family: 'inter';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
  font-style: normal;
  font-weight: 600;
}

@font-face {
  font-family: 'inter';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype');
  font-style: normal;
  font-weight: 700;
}

@font-face {
  font-family: 'inter';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('opentype');
  font-style: normal;
  font-weight: 900;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/fonts.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,+DAA+E;EAC/E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,+DAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,+DAA4E;EAC5E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,+DAA2E;EAC3E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,+DAA6E;EAC7E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,+DAAyE;EACzE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,+DAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'inter';\n  src: url('../../../assets/fonts/inter/Inter-ExtraLight.ttf') format('opentype');\n  font-style: normal;\n  font-weight: 200;\n}\n\n@font-face {\n  font-family: 'inter';\n  src: url('../../../assets/fonts/inter/Inter-Light.ttf') format('opentype');\n  font-style: normal;\n  font-weight: 300;\n}\n\n@font-face {\n  font-family: 'inter';\n  src: url('../../../assets/fonts/inter/Inter-Regular.ttf') format('opentype');\n  font-style: normal;\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: 'inter';\n  src: url('../../../assets/fonts/inter/Inter-Medium.ttf') format('opentype');\n  font-style: normal;\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: 'inter';\n  src: url('../../../assets/fonts/inter/Inter-SemiBold.ttf') format('opentype');\n  font-style: normal;\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: 'inter';\n  src: url('../../../assets/fonts/inter/Inter-Bold.ttf') format('opentype');\n  font-style: normal;\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: 'inter';\n  src: url('../../../assets/fonts/inter/Inter-Black.ttf') format('opentype');\n  font-style: normal;\n  font-weight: 900;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
